import { Stack, Box, Button, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ListIcon from "@mui/icons-material/List";
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import moment from "moment";
import axiosClient from '../../../../../lib/axios';
import { INotaFiscal, Parcelas } from "../../../../../types/api/fiscal/detalhe-nfe-entrada";
import { useState } from "react";
import Visibility from '@mui/icons-material/Visibility';
import DialogDetalheParcelasNF from "./DialogDetalheParcelasNF";
export default function CardFiscaisResumo({
  data
}: PropsCardFiscaisResumo) {

  const [openModalDetalheParcela, setOpenModalDetalheParcela] = useState<TOpenParcela | null>(null);

  const formatarChaveAcesso = (chave: string) => {
    if (!chave) return '';
    const chaveLimpa = chave.replace(/\s/g, '');
    return chaveLimpa.match(/.{1,4}/g)?.join(' ') || chave;
  };

  const formatarValor = (valor: string) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number(valor));
  };

  const formatarData = (data: string) => {
    return moment(data).format('DD/MM/YYYY');
  };

  const handleDownloadXML = () => {
    axiosClient.get(`/fiscal/nfe-entrada/${data.id}/xml`, {
      responseType: 'blob',
    }).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${data.numero_nota}.xml`;
      link.click();
    });
  };

  return (
    <PaperBox>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ flex: 1 }}>
        <DadoValorPrinter
          titulo="Espécie/Número/Série"
          valor={`NFe ${data.numero_nota} - Série ${data.serie_nota}`}
        />
        <Box sx={{ textAlign: 'right' }}>
          <DadoValorPrinter
            alignTitle="right"
            titulo="Valor total"
            valor={`${formatarValor(data.valor_total)}`}
          />
        </Box>
      </Stack>
      <DadoValorPrinter
        titulo="Frete"
        valor={`${formatarValor(data.frete)}`}
      />
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ flex: 1 }}>
        <DadoValorPrinter
          titulo="Parcelas"
          valor={data.parcelas ? `${data.parcelas.duplicatas.length}` : 'Não informado'}
        />
        {
          data.parcelas && data.parcelas.duplicatas.length > 0 &&
          <Box sx={{ textAlign: 'right' }}>
            <IconButton onClick={() => setOpenModalDetalheParcela({ open: true, parcela: data.parcelas })} aria-label="edit" size="small" sx={{ marginLeft: 1 }}>
              <Visibility fontSize="small" />
            </IconButton>
          </Box>
        }
      </Stack>
      <DadoValorPrinter
        titulo="Origem"
        valor={`${data.nome_emissor}`}
      />
      <DadoValorPrinter
        titulo="Destino"
        valor={`${data.nome_destinatario}`}
      />
      <DadoValorPrinter
        titulo="Natureza da Operação"
        valor={`${data.natureza_operacao}`}
      />
      <DadoValorPrinter
        titulo="Data da Emissão"
        valor={`${formatarData(data.data_emissao)}`}
      />

      <DadoValorPrinter
        titulo="Chave NFe"
        valor={`${formatarChaveAcesso(data.chave)}`}
      />
      <Stack direction="row" justifyContent="space-between" sx={{ mt: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<DownloadIcon />}
          sx={{ borderRadius: 10 }}
          onClick={handleDownloadXML}
        >
          Ver .XML
        </Button>
        <Button
          variant="outlined"
          color="primary"
          disabled
          startIcon={<ListIcon />}
          sx={{ borderRadius: 10 }}
        >
          Ver DANFE
        </Button>
      </Stack>
      {
        openModalDetalheParcela && openModalDetalheParcela.open && openModalDetalheParcela.parcela &&
        <DialogDetalheParcelasNF
          open={openModalDetalheParcela.open}
          onClose={() => setOpenModalDetalheParcela(null)}
          parcelas={openModalDetalheParcela.parcela}
        />

      }
    </PaperBox>
  )
}

interface PropsCardFiscaisResumo {
  data: INotaFiscal
}

export type TOpenParcela = {
  open: boolean;
  parcela: Parcelas | null;
}